import React from 'react';

const CourtPanel = ({ bucketName, courtData, courts }) => {
  if (!courtData) return null;
  const entries = courts.map(c => ({ court: c, count: courtData[c] || 0 }));
  if (entries.length === 0) return null;
  const maxCount = Math.max(...entries.map(e => e.count), 1);

  return (
    <div className="court-panel">
      <h4 className="court-panel-title">{bucketName}</h4>
      <div className="court-bars">
        {entries.map(({ court, count }) => (
          <div className="court-bar-row" key={court}>
            <span className="court-label">{court}</span>
            <div className="court-bar-track">
              <div className="court-bar-fill" style={{ width: `${(count / maxCount) * 100}%` }} />
            </div>
            <span className="court-count">{count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourtPanel;
